<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 240px">
        <p>供应商名称：</p>
        <el-input v-model="teamIpt" size="mini" style="width:150px" placeholder="请输入供应商名称"/>
      </div>
      <div class="navContainer" style="width: 240px">
        <p>车牌号：</p>
        <el-input v-model="license" size="mini" style="width:150px" placeholder="请输入车牌号"/>
      </div>
      <div class="navContainer" style="width: 250px">
        <p>司机任务编号：</p>
        <el-input v-model="driverTaskNumber" size="mini" style="width:150px" placeholder="请输入司机任务编号"/>
      </div>
<!--      <div class="navContainer" style="width: 230px">-->
<!--        <p>司机姓名：</p>-->
<!--        <el-input v-model="nameIpt" size="mini" style="width:150px" placeholder="请输入司机姓名"/>-->
<!--      </div>-->

<!--      <div class="navContainer" style="width: 480px">-->
<!--        <p>换板时间：</p>-->
<!--        <el-date-picker-->
<!--          v-model="timeIpt"-->
<!--          type="datetimerang"-->
<!--          size="mini"-->
<!--          value-format="yyyy-MM-dd HH:mm:ss"-->
<!--          range-separator="至"-->
<!--          start-placeholder="开始装船时间"-->
<!--          end-placeholder="结束装船时间"/>-->
<!--      </div>-->
      <div class="navContainer">
        <p>状态：</p>
        <el-select v-model="stateIpt" filterable size="mini" style="width:150px" placeholder="请选择状态">
          <el-option  label="全部" value=""/>
          <el-option  label="待换板" value="0"/>
          <el-option  label="完成换板" value="1"/>
          <el-option  label="取消换板" value="-1"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        <el-button size="small" type="primary" @click="addBtn">添加</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" align="center" width="50px">
            <div slot-scope="scope">{{scope.$index+1}}</div>
          </el-table-column>
          <el-table-column prop="driverTaskNumber" label="司机任务编号" align="center"/>
          <el-table-column prop="fleetName" label="供应商名称" align="center"/>
          <el-table-column prop="license" label="车牌号" align="center"/>
          <el-table-column prop="driverName" label="司机姓名" align="center"/>
          <el-table-column prop="driverPhone" label="司机电话" align="center" min-width="100" />
          <!-- <el-table-column prop="loadingCount" label="装车数量" align="center"/> -->
          <el-table-column prop="changeReason" label="换板原因" align="center"/>
          <el-table-column prop="changeLicense" label="换板车牌号" align="center"/>
          <el-table-column prop="changDriverName" label="换板司机姓名" align="center"/>
          <el-table-column prop="changeDriverPhone" label="换板司机电话" align="center" min-width="100"/>

          <el-table-column prop="changeTime" label="换板时间" align="center"/>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope" >{{statusFormat(scope.row.status)}}</template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <div>
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row.id)">详情</el-button>
                <el-button size="mini" type="danger" @click="deleteClick(scope.row.id)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{total}}条</span>
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="sizes,prev, pager, next,jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          @prev-click="contractCurrentChange"
          @next-click="contractCurrentChange"
        />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='800px' center top="10vh">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line"/>
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">换板原因：</span>
              <span>{{detailData.changeReason}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">换板时间：</span>
              <span>{{detailData.changeTime}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">原因：</span>
              <span>{{detailData.remark}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">司机任务编号：</span>
              <span>{{detailData.driverTaskNumber}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">托运车牌号：</span>
              <span>{{detailData.license}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">所属供应商：</span>
              <span>{{detailData.fleetName}}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">托运司机姓名：</span>
                <span>{{detailData.driverName}}</span>
              </div>
              <div>
                <span class="span1">托运司机电话：</span>
                <span>{{detailData.driverPhone}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">换板司机姓名：</span>
                <span>{{detailData.changDriverName}}</span>
              </div>
              <div>
                <span class="span1">换板司机电话：</span>
                <span>{{detailData.changeDriverPhone}}</span>
              </div>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">换板车牌号：</span>
              <span>{{detailData.changeLicense}}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">照片：</span>
              <div class="imgContainer">
                <el-image
                  v-for="(item,index) in detailData.img"
                  :key="index"
                  style="width: 100px; height: 100px;margin-right:10px; "
                  :src="baseImgUrl + item"
                  :preview-src-list="[baseImgUrl + item]"
                  fit="cover"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>委托车信息</span>
          </div>
          <div class="operationTable">
            <el-table :data="carData" border style="width: 100%">
              <el-table-column prop="billNumber" label="运单号" align="center"/>
              <el-table-column prop="frameNumber" label="车架号" align="center"/>
              <el-table-column prop="brand" label="品牌" align="center"/>
              <el-table-column prop="model" label="型号" align="center"/>
              <el-table-column prop="config" label="配置" align="center"/>
              <el-table-column prop="color" label="颜色" align="center"/>
              <el-table-column prop="weight" label="重量" align="center"/>
              <el-table-column prop="lwh" label="长x宽x高" align="center"/>
              <el-table-column prop="fileName" label="附件" align="center"/>
            </el-table>
          </div>
        </div>
        <div class="operation">
          <div class="operationTitle">
            <div class="line"/>
            <span>操作记录</span>
          </div>
          <div class="operationTable">
            <el-table :data="operationData" border style="width: 100%">
              <el-table-column label="序号" align="center" width="50px">
                <div slot-scope="scope">{{scope.$index+1}}</div>
              </el-table-column>
              <el-table-column label="操作时间" align="center">
                <div slot-scope="scope">{{getTime(scope.row.createTime)}}</div>
              </el-table-column>
              <el-table-column prop="operateType" label="操作类型" align="center"/>
              <el-table-column prop="operationName" label="操作人" align="center"/>
              <el-table-column prop="remark" label="备注" align="center"/>
            </el-table>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width='650px' center @close="dialogClose" :close-on-click-modal="false" top="10vh">
      <div class="company">
        <el-form :model="boardData" label-width="110px" :rules="rules" ref="ruleForm">
          <divBorder label="运输车信息" prop="transInfo">
            <el-form-item label="司机任务编号：" prop="waybill" style="margin-top: 15px;margin-bottom: 0">
              <div style="display: flex;align-items: center;justify-content: space-between">
                <el-input
                  :style="'width:85%'"
                  v-model="boardData.waybill"
                  placeholder="请输入司机任务编号"
                  autocomplete="off"
                  size="small"
                />
                <el-button size="small" class="searchBtn" @click="waybillSearch">查询</el-button>
              </div>
            </el-form-item>
            <div style="display: flex;align-items: center;">
              <el-form-item label="车牌号：" style="margin-bottom: 0;width:50%">
                <span v-if="boardData.truckName">{{boardData.truckName}}</span>
              </el-form-item>
              <el-form-item label="所属车队：" style="margin-bottom: 0;">
                <span v-if="boardData.supplierName">{{boardData.supplierName}}</span>
              </el-form-item>
            </div>
            <div style="display: flex;align-items: center;">
              <el-form-item label="司机姓名：" style="margin-bottom: 0;width:50%">
                <span v-if="boardData.driverName">{{boardData.driverName}}</span>
              </el-form-item>
              <el-form-item label="司机电话：" style="margin-bottom: 0;">
                <span v-if="boardData.account">{{boardData.account}}</span>
              </el-form-item>
            </div>
            <!-- <el-form-item label="当前托运数量：" style="margin-bottom: 0;">
              <span v-if="boardData.count">{{boardData.count}}</span>
            </el-form-item> -->
          </divBorder>
          <divBorder label="换板车信息" prop="changeInfo">
            <el-form-item label="车牌号：" prop="parking" style="margin-top: 15px;">
              <el-select v-model="boardData.parking" size="mini" filterable style="width:85%" placeholder="请选择车牌号" value-key="vehicleId" @change="parkChange">
                <el-option v-for="item in parkingOption" :key="item.vehicleId" :label="item.license" :value="item"/>
              </el-select>
            </el-form-item>
            <el-form-item label="司机姓名：">
              <span v-if="boardData.parking.driverName">{{boardData.parking.driverName}}</span>
            </el-form-item>
            <el-form-item label="司机电话：" style="margin-bottom: 20px;">
              <span v-if="boardData.parking.driverPhone">{{boardData.parking.driverPhone}}</span>
            </el-form-item>
          </divBorder>
          <divBorder label="换板信息" prop="info">
            <el-form-item label="换板原因：" prop="reason" style="margin-top: 15px;">
              <el-select v-model="boardData.reason" filterable size="mini" style="width:85%" placeholder="请选择换板原因" value-key="id">
                <el-option v-for="item in reasonOption" :key="item.id" :label="item.attrNm" :value="item"/>
              </el-select>
            </el-form-item>
            <el-form-item label="换板时间：" prop="time" style="margin-bottom: 19px;">
              <el-date-picker
                v-model="boardData.time"
                size="mini"
                type="datetime"
                style="width:85% "
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择换板时间"/>
            </el-form-item>
            <el-form-item label="备注：" prop="mark" style="margin-bottom: 20px;">
              <el-input
                type="textarea"
                :style="'width:85%'"
                v-model="boardData.mark"
                placeholder="请输入备注"
                autocomplete="off"
                size="small"
              />
            </el-form-item>
           <el-form-item label="上传图片：" prop="img" style="margin-bottom:0">
             <div class="imgUp">
               <div class="imgLength"><span>{{boardData.img.length}}/5</span></div>
               <el-upload
                 ref="uploads"
                 list-type="picture-card"
                 :action="uploadUrl"
                 :data="uploadData"
                 accept="image/png, image/jpeg, image/jpeg, image/bmp, image/gif"
                 :before-upload="beforeAvatarUpload"
                 :on-change="uploadChange"
                 :on-remove="handleRemove"
                 :on-progress="progress"
                 :on-success="success"
                 :file-list="boardData.img"
                 :limit="5"
               >
                 <div class="img-box">
                   <i class="el-icon-plus"/>
                   <span class="tips">点击上传图片</span>
                 </div>
               </el-upload>
             </div>
           </el-form-item>
          </divBorder>
          <div class="btnContainer">
            <el-button class="searchBtn" @click="addClick" :loading="imgIsUpload" size="small">确定</el-button>
            <el-button class="resetBtn" @click="dialogClose" size="small">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import divBorder from "@/components/divBorder";
import {
  changeInfoCvPageList,
  changeInfoCvGetInfoByBill,
  changeInfoCvGetCarByFleetId,
  changeInfoCvGetInfoByDriverId,
  changeInfoCvAdd,
  changeInfoCvDelete,
  changeInfoCvDetail,
} from "@/service/vehiclelog";
import {getParam} from "@/service/getData";
import {baseImgUrl, baseUrl} from "@/config/env";
import {formatDateTime, getSessionStore} from "@/config/mUtils";

export default {
  components: {
    divBorder
  },
  data() {
    return {
      nameIpt:'',
      driverTaskNumber:'',
      teamIpt:'',
      timeIpt:'',
      license:"",
      stateIpt:"",
      page:1,
      size:10,
      total:0,
      tableLoad:false,
      TableDatas:[],
      detailDialogVisible:false,
      detailData:{
        reason:'原因1111',
        time:'2021-9-1 15:29',
        remark:'',
        waybill:'BH201215412',
        parking:'渝A00000',
        name:'周世鹏',
        tell:'177000000000',
        newParking:'渝A212000',
        newName:'李四',
        newTell:'1770000000',
      },
      carData:[],
      operationData:[],
      dialogTitle:'',
      dialogVisible:false,
      parkingOption:[],
      boardData:{
        reason:'',
        time:'',
        mark:'',
        waybill:'',
        parking:'',
        name:'',
        tell:'',
        parking1:'',
        name1:'',
        tell1:'',
        img:[],
      },
      rules:{
        info:[
          { required: true, message: ' ', trigger: 'blur' },
        ],
        transInfo:[
          { required: true, message: ' ', trigger: 'blur' },
        ],
        changeInfo:[
          { required: true, message: ' ', trigger: 'blur' },
        ],
        reason:[
          { required: true, message: '请选择换板原因', trigger: 'change' },
        ],
        time:[
          { required: true, message: '请选择换板时间', trigger: 'change' },
        ],
        waybill:[
          { required: true, message: '请输入运单编号', trigger: 'blur' },
        ],
        parking:[
          { required: true, message: '请输入车牌号', trigger: 'blur' },
        ],
        name:[
          { required: true, message: '请输入司机姓名', trigger: 'blur' },
        ],
        tell:[
          { required: true, message: '请输入司机电话', trigger: 'blur' },
        ],
      },
      reasonOption:[],
      baseImgUrl: baseImgUrl+ '/',
      uploadUrl:'',
      uploadData: {
        fileType: '1',
      },
      imgIsUpload:false,
    };
  },
  computed:{
    getTime(){
      return function(time){
        return formatDateTime(time,'yyyy年mm月dd日 hh:ii:ss')
      };
    },
    statusFormat(){
      return function (value) {
        switch (value) {
          case 0:
            return '待换版'
          case 1:
            return '完成换版'
          case -1:
            return '取消换版'
        }
      }
    },
  },
  mounted() {
    this.init();
    this.uploadUrl = baseUrl + '/web/attachmentFtp/upload'
  },
  methods: {
    async init(){
    //  await this._changeInfoCvPageList();

    },
    async _changeInfoCvPageList(){
      this.tableLoad=true;
      const res = await changeInfoCvPageList(
        {
          rows:this.size,
          page:this.page,
          fleetName:this.teamIpt,
          license:this.license,
          status:this.stateIpt,
          driverName:this.nameIpt,
          driverTaskNumber:this.driverTaskNumber,
          startTime:this.timeIpt[0]?this.timeIpt[0]:'',
          endTime:this.timeIpt[1]?this.timeIpt[1]:'',
        }
      );
      this.tableLoad=false;
      if(res.status !== 0) return this.$message.error(res.message);
      this.TableDatas=res.data.records;
      this.total=res.data.total;
    },
    dialogClose(){
      this.dialogVisible=false;
      this.$refs.ruleForm.resetFields();
    },
    contractSizeChange(sizes){
      this.size=sizes;
      this._changeInfoCvPageList();
    },
    contractCurrentChange(page){
      this.page=page;
      this._changeInfoCvPageList();
    },
    async detailClick(id){
      let token = getSessionStore('token');
      const res = await changeInfoCvDetail(id);
      if(res.status !== 0) return this.$message.error(res.message);
      this.detailDialogVisible=true;
      this.detailData= {
        ...res.data,
        img: [],
      }
      if(res.data.attachmentList && res.data.attachmentList.length > 0) {
        res.data.attachmentList.forEach(item => {
          let img = "web/attachmentFtp/download?attachmentId="+(item.id)+"&access_token="+token;
          this.detailData.img.push(img);
        })
      }
      this.carData=res.data.vdccList;
      this.operationData=res.data.operateRecordList;
    },
    deleteClick(id){
      this.$confirm('确定要删除当前换板记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        console.log(11111,id);
        const res = await changeInfoCvDelete(id);
        if(res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._changeInfoCvPageList();
      }).catch(() => {});
    },
    searchBtn(){
      this.page = 1;
      this._changeInfoCvPageList();
    },
    resetBtn(){
      this.nameIpt='';
      this.driverTaskNumber='';
      this.teamIpt='';
      this.timeIpt='';
      this.stateIpt = '';
      this.license = '';
    },
    async addBtn(){
      this.dialogVisible=true;
      this.dialogTitle='添加'
      this.boardData={
        reason:'',
        time:'',
        mark:'',
        waybill:'',
        parking:'',
        name:'',
        tell:'',
        name1:'',
        tell1:'',
        img:[],
      };
      const res = await getParam({categoryCd:'change_reason'});
      if(res.status !== 0) this.$message.error(res.message);
      else this.reasonOption=res.data.map(item=>{
        return {
          attrNm:item.classaName,
          id:item.id,
        }
      });
    },
    async parkChange(){
      console.log(this.boardData.parking);
      // const res = await changeInfoCvGetInfoByDriverId(this.boardData.parking.driverId);
      // if(res.status !== 0) return this.$message.error(res.message);
      // this.boardData.tell1=res.data.account;
      // this.boardData.name1=res.data.name;
      // this.boardData.changeDriverId=res.data.id;
    },
    async waybillSearch(){
      if(!this.boardData.waybill) return this.$message.warning('请输入运单号以查询信息！');
      const res = await changeInfoCvGetInfoByBill(this.boardData.waybill);
      if(res.status !== 0) return this.$message.error(res.message);
      this.boardData={
        ...this.boardData,
        ...res.data.vddc,
        account: res.data.oldDriver.phoneNumber?res.data.oldDriver.phoneNumber:'',
      }
      this.parkingOption = res.data.freeCarList;
      // const res2 = await changeInfoCvGetCarByFleetId(res.data.fleetId);
      // if(res2.status !== 0) return this.$message.error(res2.message);
      // this.parkingOption=res2.data;
    },
    addClick(){
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          let str ='';
          this.boardData.img.forEach(item=>{
            console.log(item);
            if(!item.response) str+=item.url.split(baseImgUrl+'/')[1]+','
            else str += item.response.data.id + ',';
          })
          str = str.slice(0,str.length-1);
          this.imgIsUpload = true;
          // return false
          const res = await changeInfoCvAdd(
            {
              // changeReason:this.boardData.reason.attrNm,
              // changeTime:this.boardData.time,
              // remark:this.boardData.mark,
              // imgUrl:str,
              // license:this.boardData.license,
              // fleetId:this.boardData.fleetId,
              // fleetName:this.boardData.fleetName,
              // driverId:this.boardData.driverId,
              // driverName:this.boardData.driverName,
              // driverPhone:this.boardData.phone,
              // amount:this.boardData.count,
              // changeLicenseId:this.boardData.parking.id,
              // changeLicense:this.boardData.parking.license,
              // changeDriverId:this.boardData.changeDriverId,
              // changDriverName:this.boardData.name1,
              // changeDriverPhone:this.boardData.tell1,

              driverTaskNumber:this.boardData.waybill,  // 司机任务编码
              driverPhone: this.boardData.account,  // 司机电话
              changeReasonId: this.boardData.reason.id,  // 换板原因id
              changeReason: this.boardData.reason.attrNm, // 换板原因
              changeLicenseId: this.boardData.parking.vehicleId, // 换板车id
              changeDriverPhone: this.boardData.parking.driverPhone, // 换板司机电话
              changeTime: this.boardData.time,   // 换板时间
              remark: this.boardData.mark, // 备注
              imgIdStr: str,  // 附件图片id
            }
          );
          this.imgIsUpload = false;
          if(res.status !== 0) return this.$message.error(res.message);
          this.$message.success(res.message);
          this.dialogVisible=false;
          await this._changeInfoCvPageList();
        } else return false;
      });
    },
    beforeAvatarUpload(file) {
      const TypeArr = ['image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/jpg']
      const isJPG =TypeArr.includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isJPG) this.$message.error('上传图片只能为jpg/png/jpeg/bmp/gif格式')
      if (!isLt10M) this.$message.error('上传图片大小不能超过 10MB')
      return isJPG && isLt10M
    },
    uploadChange(file, fileList){
      this.boardData.img=fileList;
      if (Object.keys(file).includes('response')){
        if (file.response.status !==0){
          this.boardData.img.splice(this.boardData.img.indexOf(file),1)
        }
      }
    },
    handleRemove(file,fileList) {
      this.boardData.img=fileList;
    },
    progress(){
      this.imgIsUpload=true;
    },
    success(res){
      if(res.status!==0) this.$message.error('该图片上传失败！')
      this.$message.success(res.message)
      this.imgIsUpload=false;
    },
  },
};
</script>

<style lang="scss" scoped>
.mainContainer{
  width:100%;
  padding:20px 15px 0 25px;
  background-color: #fff;
  .img-box{
    position: relative;
    width: 150px;
    height: 100px;
    img{
      width: 150px;
      height: 100px;
    }
    .tips{
      position: absolute;
      display:none;
    }
    &:hover .tips{
      display:block;
      position:absolute;
      //bottom:0;
      top:0;
      left:0;
      color:#FFF;
      width:146px;
      z-index:10;
      height:148px;
      background:#000;
      opacity: 0.6;
    }
  }
  .btnContainer{
    width:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0 5px 0;
    button{
      margin: 0 15px;
    }
  }
  .line{
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }
  .line +span{
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }
  .nav{
    width:100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    &Container{
      width:200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;
      p{
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }
    &Btn{
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
  }
  .company{
    width:100%;
    padding: 20px 10px 10px 10px;
    max-height:80vh;
    overflow:auto;
    .imgUp{
      display: flex;
      flex-direction: column;
      margin-bottom: 10px;
      .imgLength{
        display: flex;
        align-items: center;
        width:100%;
        span{
          margin-left:auto;
          color: rgb(183, 183, 183);
          font-size: 16px;
        }
      }
    }
    .transport{
      width:100%;
      border: 1px solid #C3C3C3;
      position:relative;
      padding:0 10px;
      margin-bottom: 20px;
      &Title{
        margin-bottom: 0;
        position:absolute;
        top: -21px;
        z-index: 999;
        background-color: #fff;
        left:20px;
        padding-right:10px;
        color: rgb(51, 84, 131);
        font-size: 15px;
        font-weight:700;
        ::v-deep{
          .el-form-item__label{
            color: rgb(51, 84, 131);
            font-size: 15px;
          }
        }
      }
    }
    .productTable{
      margin-top:15px;
      ::v-deep{
        .el-input--mini .el-input__inner{
          width: 100%;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
        .el-table td, .el-table th{
          padding:0;
        }
      }
      .tableAddBtnContainer{
        border: 1px solid #EBEEF5;;
        border-top-style: none;
        width: 100%;
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 15px;
        .AddContainer{
          display: flex;
          align-items: center;
          &:hover{
            cursor: pointer;
          }
        }
        img{
          object-fit: cover;
          margin-right: 5px;
        }
        p{
          font-size: 13px;
          color: #F59A23;
          font-family: 'Arial Normal', 'Arial', sans-serif;
        }
      }
    }
    .update{
      font-size: 14px;
      color: rgba(51, 136, 255, 1);
      text-decoration: underline;
    }
    ::v-deep{
      .el-form-item__label{
        font-weight: 700;
      }
      .el-form-item__label{
        padding:0;
      }
      .el-form-item{
        margin-bottom:15px;
      }
      .el-form-item__content{
        position: relative;
      }
    }
    hr{
      margin: 0;
      position: absolute;
      width: 100%;
      bottom: 5px;
    }
  }
  .content{
    display: flex;
    flex-direction: column;
    align-items: center;
    .tableContainer{
      margin-top: 15px;
      margin-bottom: 25px;
      width: 100%;
      ::v-deep{
        .el-table .cell {
          padding: 0;
        }
        .el-table th{
          padding: 0;
        }
        .el-table td{
          padding: 0;
        }
      }
    }
    .paginationContainer{
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      span{
        font-size: 13px;
      }
    }
  }
  .detail{
    width: 100%;
    padding: 10px 0 20px 20px;
    max-height:80vh;
    overflow: auto;
    .baseInfo{
      display: flex;
      flex-direction: column;
      .imgContainer {
        padding-top: 10px;
        padding-left: 40px;
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Content{
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        padding:20px 23px 0 23px;
        &Item{
          margin-bottom: 20px;
          .addressItem{
            font-size: 12px;
            color: rgba(153, 153, 153, 1);
            margin-bottom: 10px;
            margin-left: 70px;
          }
          .span1{
            font-weight: 700;
          }
          span{
            font-size: 14px;
          }
          .specialOne{
            width:50%;
          }
        }
        .specialItem{
          display:flex;
        }
      }
    }
    .operation{
      display: flex;
      flex-direction: column;
      ::v-deep{
        .el-table td, .el-table th{
          padding:0;
        }
        .cell{
          font-size: 10px;
          padding:0;
        }
      }
      &Title{
        display:flex;
        align-items:flex-end;
        p{
          font-weight: 700;
          font-size: 14px;
          color: rgba(51, 136, 255, 1);
          margin-left: 10px;
        }
      }
      &Table{
        width:100%;
        margin-top: 10px;
        padding: 0 20px;
      }
    }
  }
  ::v-deep{
    .el-table th>.cell{
      font-weight: 700!important;
    }
  }
}
::v-deep{
  .el-table .ui-warning-row {
    background: #DDD!important;
  }
  .el-table .ui-warning-row .cell{
    color: red;
  }
  .el-dialog__header {
    padding: 9px 20px 9px;
    background: #335483;
  }
  .el-dialog__title {
    line-height: 24px;
    font-size: 14px;
    color: #FFFFFF;
  }
  .el-dialog__headerbtn{
    top:9px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #fff;
    font-size: 25px;
  }
  .el-dialog__body {
    padding: 0;
  }
}
</style>
